import default_es_sub_status_messages from '../es/substatusMessages'

export default {
  ...default_es_sub_status_messages,
  subStatusCreditRatingError: 'En Analisis de crédito aguarde 36 hrs habiles',
}
